import React, { useState, useEffect } from "react";
import FooterLink from "./footer-link";

interface LinkItem {
  label: string;
  uri: string;
  cssClasses: string;
}

interface FooterCategoryProps {
  title: string;
  items: LinkItem[];
  isTopSection?: boolean;
}

const FooterCategory = ({ title, items, isTopSection }: FooterCategoryProps) => {
  const [itemsToShow, setItemsToShow] = useState<LinkItem[]>([]);
  const [hiddenItems, setHiddenItems] = useState<LinkItem[]>([]);
  const [showMore, setShowMore] = useState<boolean>(false);
  // We don't hide extra links in the top section
  const needShowMore = items.length > 5 && !isTopSection;

  useEffect(() => {
    if (needShowMore && !showMore) {
      const firstFive = items.slice(0, 5);
      const hidden = items.slice(5);
      setItemsToShow(firstFive);
      setHiddenItems(hidden);
    } else {
      setItemsToShow(items);
      setHiddenItems([]);
    }
  }, [items]);

  const handleShowMore = () => {
    if (showMore) {
      const firstFive = items.slice(0, 5);
      const hidden = items.slice(5);
      setItemsToShow(firstFive);
      setHiddenItems(hidden);
    } else {
      setItemsToShow(items);
      setHiddenItems([]);
    }

    setShowMore(prevShow => !prevShow);
  }

  return (
    <div className="footer-category">
      <p className="footer-category-title">{title}</p>
      <div className="footer-category-items">
        {itemsToShow.map((item, i) => (
          <FooterLink key={i} href={item.uri} text={item.label} className={item.cssClasses} />
        ))}
        {hiddenItems.length > 0 && hiddenItems.map((item, i) => (
          <FooterLink key={i} href={item.uri} text={item.label} hidden={true} className={item.cssClasses} />
        ))}
      {needShowMore && <p className="footer-category-show-more" onClick={handleShowMore}>{showMore ? 'Show less' : 'Show more'}</p>}
      </div>
    </div>
  );
}

export default FooterCategory;
